import React from "react"
import { Link } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { Container, Row, Col, Badge } from "react-bootstrap"
import { ArrowRight, ShoppingBag, Briefcase, Maximize, Check } from "react-feather"
import Layout from "../components/layout"
//import Image from "../components/image"
import SEO from "../components/seo"
import Hero from "../components/hero"
import FAQ from "../components/faq"
import CallToAction from "../components/cta"


import HomeDemo from "../components/home-demo"


const IndexPage = () => (
  <Layout>
    <SEO
      title="Simple and affordable web scraping API"
      description="ScrapeOwl is easy to use and powerful web scraping and parsing API that handles proxies and headless browsers, so you can focus on the data you want."
    />

    <div className="hero">
      <Container className="underlined">
        <Row>
          <Col md="12" lg="5" className="hero-col mb-5 mt-10">
            {
              /*
            <Link to="/pricing" id="shout-link">
              <div className="shout">
                <div className="shout-title">
                  LAUNCH
                </div>
                <div className="shout-text">
                  Get 25% off all plans
                </div>
                <ArrowRight className="titular-arrow" />
              </div>
            </Link>
              */
            }

            <h1>Simple and Affordable Web Scraping API</h1>
            <p>
              Focus on scraping the data you need, not on proxies, headless browsers, and HTML parsing. Just select the elements you want from anywhere and we'll get them for you.
            </p>

            <div className="actions">
              <a href="https://app.scrapeowl.com/register" className="black-button">
                Create an account
              </a>
              {/* <span>or</span> */}
              <ScrollLink to="try-me" style={{ marginLeft: '20px' }} className="secondary-button" spy={true} hashSpy={true} smooth={true} offset={90} duration={500}>
                Try it<ArrowRight className="titular-arrow" />
              </ScrollLink>
            </div>

            <div className="d-flex flex-column flex-sm-row my-3">
              <div className="mr-4 py-2">
                <Check className="sub-text-check" />
                <span className="sub-text">1000 Free API Calls</span>
              </div>
              <div className="mr-4 py-2">
                <Check className="sub-text-check" />
                <span className="sub-text">No Credit Card Required</span>
              </div>
            </div>

            <div style={{ marginTop: 30 }}>
              <a href="https://www.producthunt.com/posts/scrapeowl?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-scrapeowl" target="_blank">
                <img src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=270712&theme=light&period=daily" alt="ScrapeOwl - Simple and powerful web scraping API | Product Hunt" width="250" height="54" style={{ width: 250, height: 54, float: 'none' }} />
              </a>
            </div>

            {/* <div className="d-flex flex-column flex-sm-row my-3">
              <div className="mr-4 py-2">
                <Check className="sub-text-check" />
                <span className="sub-text">No Credit Card Required</span>
              </div>
              <div className="mr-4 py-2">
                <Check className="sub-text-check" />
                <span className="sub-text">Free API Calls</span>
              </div>
            </div> */}

            {/* <img src={heroImg} alt="hero" /> */}
          </Col>
          <Col className="hero-col-2" md="12" lg="7">

            <Hero />

          </Col>
        </Row>
      </Container>
    </div>



    <div className="use-cases-wrapper">
      <Container>
        <div className="centerite">
          <span className="sectionite">
            built for
            </span>
          <h2>Use Cases </h2>
        </div>
        <Row className="usecase-container">
          <Col md="12" lg="4" className="use-case">
            <div className="use-case-header">
              <ShoppingBag className="use-case-icon" />
              <h3>E-Commerce</h3>
            </div>
            <p>Track products and get data from platforms like Amazon or Shopify</p>
          </Col>
          <Col md="12" lg="4" className="use-case">
            <div className="use-case-header">
              <Briefcase className="use-case-icon" />
              <h3>Job Boards</h3>
            </div>
            <p>Get jobs from Stackoverflow, Linkedin and company job boards</p>
          </Col>
          <Col md="12" lg="4" className="use-case">
            <div className="use-case-header">
              <Maximize className="use-case-icon" />
              <h3>Real Estate Listings</h3>
            </div>
            <p>Aggregate available real estate in various regions in the world</p>
          </Col>
        </Row>
      </Container>
    </div>



    <div className="demo-wrapper">
      <div className="container">
        <HomeDemo />
      </div>
    </div>

    <div id="features" className="features">
      <Container>
        <Row>
          <Col md="12" lg="12" className="features-section">
            <h2>API Features</h2>
            {/* <p>
              Full feature set that allows you to selectively scrape content from the web.
            </p> */}
          </Col>

        </Row>

        <Row className="m-0">
          <Col md="12" lg="9" className="feature-items-col">
            <Row className="features-container">
              <Col className="vertical-features">

                <span className="column-title">Javascript</span>


                <div className="feature-items">
                  <Row className="l1">
                    <span>
                      <Badge className="demo-badge">elements</Badge>

                    </span>
                    <span className="feature-description">
                      Specify the elements you care about and get them
                      </span>

                  </Row>
                  <Row className="l2">
                    <span>
                      <Badge className="demo-badge">custom_js</Badge>

                    </span>
                    <span className="feature-description">
                      Run custom JS prior to extraction of content
                      </span>

                  </Row>
                </div>
              </Col>
              <Col className="vertical-features">

                <span className="column-title">Proxies</span>


                <div className="feature-items">
                  <Row className="m1">
                    <span>
                      <Badge className="demo-badge">country</Badge>

                    </span>
                    <span className="feature-description">
                      Set location to evade limits and get local content
                      </span>
                  </Row>
                  <Row className="m2">
                    <span>
                      <Badge className="demo-badge">premium_proxies</Badge>
                    </span>
                    <span className="feature-description">
                      Present yourself as a real user to the target
                      </span>
                    {/* <span className="premium">FOR BUSINESS</span> */}
                  </Row>
                </div>
              </Col>
              <Col className="vertical-features">

                <span className="column-title">Plus</span>

                <div className="feature-items">
                  <Row className="r1">

                    <span>
                      <Badge className="demo-badge badge">wait_for</Badge>
                    </span>
                    <span className="feature-description">
                      Wait for a specific element or preset amount of time
                    </span>

                  </Row>
                  <Row className="r2">
                    <span>
                      <Badge className="demo-badge">render_js</Badge>
                    </span>
                    <span className="feature-description">
                      Load full page before scraping its content
                    </span>

                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

      </Container>
      <Link to="/pricing" className="secondary-button see-price">See Pricing <ArrowRight className="big-titular-arrow" /></Link>

    </div>

    <FAQ />

    <CallToAction />
  </Layout>
)

export default IndexPage
